import { ControllerFlowAPI } from 'yoshi-flow-editor-runtime/build/cjs/flow-api/ViewerScript';
import { V1Challenge } from '@wix/ambassador-challenge-service-web/types';
import format from 'date-fns/format';

const getDatesConfig = (
  challenge: V1Challenge,
): { lastMod: string; created: string } => {
  const { transitions } = challenge;
  const lastDate = format(new Date(transitions[0].occurredAt), 'd-MM-yyyy');

  if (transitions.length === 1) {
    return {
      lastMod: lastDate,
      created: lastDate,
    };
  }

  return {
    lastMod: lastDate,
    created: format(
      new Date(transitions[transitions.length - 1].occurredAt),
      'd-M-yyyy',
    ),
  };
};

const getPricingData = (
  challenge: V1Challenge,
): { currency: string; price: string } => {
  const currency = challenge.settings.pricing?.singlePayment?.price?.currency;

  return {
    ...(currency && { currency }),
    price: challenge.settings.pricing?.singlePayment?.price?.amount || '0',
  };
};

const getImageData = (
  challenge: V1Challenge,
): { id: string; height: string; width: string } | null => {
  const { media } = challenge.settings.description;
  if (media?.image?.id) {
    return {
      id: media?.image?.id,
      width: '1000',
      height: '800',
    };
  }

  return null;
};

export async function renderSeoMetatags(
  flowAPI: ControllerFlowAPI,
  challenge: V1Challenge,
) {
  const { isViewer } = flowAPI.environment;

  if (!isViewer) {
    return;
  }

  const { wixCodeApi } = flowAPI.controllerConfig;
  const seoAPI = wixCodeApi.seo;
  const { url, query } = wixCodeApi.location;
  const shareTitle = query.shareTitle;

  const name = challenge
    ? shareTitle
      ? decodeURIComponent(shareTitle)
      : challenge.settings?.description?.title
    : null;
  const description = challenge
    ? challenge.settings?.description?.details
    : null;

  const itemData = challenge
    ? {
        challenge: {
          id: challenge.id,
          ...getDatesConfig(challenge),
          url,
          name,
          ...(description && {
            description,
          }),
          registration: {
            availability: challenge.settings.accessRestrictions.accessType,
            ...getPricingData(challenge),
          },
          ...(getImageData(challenge) && {
            mainImage: getImageData(challenge),
          }),
        },
      }
    : {
        challenge: {
          url,
          registration: {
            availability: 'SECRET',
          },
        },
      };
  // tslint:disable-next-line
  await seoAPI.renderSEOTags({
    itemType: 'CHALLENGES_PAGE',
    itemData,
    seoData: challenge?.settings?.seo?.seoData,
  });
}
